<ion-app class="exam">
  @if (state.showFullScreenLoader) {
    <div class="bg-neutral-0 absolute z-[1000000] flex h-full w-full items-center justify-center">
      <dojo-loader [centered]="true" />
    </div>
  } @else {
    @if (state.showLoadingBar) {
      <div class="bg-neutral-0 fixed left-0 top-0 z-[1000000] w-full">
        <mat-progress-bar class="w-full" mode="indeterminate"></mat-progress-bar>
      </div>
    }
  }

  <router-outlet />

  <dojo-debugging-window *ngIfFeatureFlag="ExamDojoFeatureFlag.Testing" />
</ion-app>
